import { useContext, useEffect, useState } from 'react';
import PlansHeader from './header';
import SelectPlan from './selectPlan';
import { IModelPlans } from './types';
import {
    SegmentEventNameTypes,
    SegmentEventPageTypes,
    SegmentEventPages,
    PRODUCT,
    SUB_PRODUCT_NAME,
} from 'utils/segment/constants';
import { MPosContext } from 'utils/context';
import { useSegmentViewEvents } from 'hooks/useSegmentView';
import { useViewport } from 'utils/responsive';
import { PageLoader } from 'utils/styles';
import { getImageBasePath } from 'utils/generics';
import ErrorPage from 'widgets/errorScreen';
import * as Styles from './styles';

function Plans() {
    const { partnerId, planDetails, permissions } = useContext(MPosContext);

    const [showError, setShowError] = useState(false);
    const [plans, setPlans] = useState<IModelPlans[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const { isMobile } = useViewport();

    /**
     * view segment hook
     */

    useSegmentViewEvents(SegmentEventNameTypes.VIEW, {
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_type: SegmentEventPageTypes.MAIN_PAGE,
        view_name: SegmentEventPages.VIEW_PLAN,
        product: PRODUCT,
        sub_product_name: SUB_PRODUCT_NAME,
        platform: isMobile ? 'mweb' : 'web',
        referrer: document.referrer || '',
        device: navigator.userAgent || '',
        partner: partnerId,
    });

    useEffect(() => {
        import('./apis').then(async (req) => {
            const { status, plans } = await req.getModelPlans(
                partnerId,
                planDetails.device.id,
                permissions.group
            );
            if (status && plans.length > 0) {
                setPlans(plans);
                setShowError(false);
            } else {
                setShowError(true);
            }
            setIsLoading(false);
        });
    }, []);

    if (showError) {
        return <ErrorPage hideHeader={true} />;
    }

    return (
        <Styles.Wrapper>
            <PlansHeader />
            {isLoading ? (
                <PageLoader src={getImageBasePath('/gif/pageLoader.gif')} />
            ) : (
                <SelectPlan plans={plans} />
            )}
        </Styles.Wrapper>
    );
}

export default Plans;
